import React, { FC } from 'react'
import { ItemProps } from '../../types'
import ValidationError from '@/components/Form/elements/ValidationError'


const LongText: FC<ItemProps> = (
	{
		formItem,
		validation,
		disabled,
		formData,
		onChange,
		onFocus,
		onBlur,
		onKeyDown,
		autoFocus,
	},
) => {
	return (
		<>
            <textarea
				name={formItem.name}
				placeholder={formItem.placeholder}
				disabled={disabled}
				className={`transition-all outline-none
                    ${formItem.disabled ? 'disabled' : ''}
                    w-full text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
                    placeholder:text-gray-400 placeholder:text-text-md
                    focus:shadow-focus focus:border-primary-500
                    hover:border-primary-500 shadow-xs
                    px-md py-2
                    ${formItem.classNames?.content || ''}
                    ${validation ? 'border-red-500 border-2 focus:border-red-600 focus:shadow-red hover:border-red-600' : ''}
                `}
				autoComplete="off"
				value={formData[formItem.name] || ''}
				onChange={(e) => onChange?.(formItem.name, e.target.value)}
				onFocus={onFocus}
				onBlur={onBlur}
				onKeyDown={onKeyDown}
				autoFocus={autoFocus}
				rows={formItem.itemOptions?.rows || 2}
            />
			<ValidationError error={validation} formItem={formItem} />
		</>
	)
}

export default LongText
